'use strict';

exports.__esModule = true;
exports.landingPages = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _uniqBy2 = require('lodash/uniqBy');

var _uniqBy3 = _interopRequireDefault(_uniqBy2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
	condition: [],
	procedure: [],
	specialty: []
};

var KEYWORD_MAX_LENGTH = 40;

var getNameAndType = function getNameAndType(keyword) {
	return { name: keyword.name, keyword_type: keyword.keyword_type, relationship_id: keyword.relationship_id, id: keyword.id };
};
var landingPages = exports.landingPages = function landingPages(state, action) {
	var response = action.response;

	if (!response) {
		response = [];
	}
	switch (action.type) {

		case 'CONDITION_LANDING_PAGES_RECEIVED':
			{
				var conditions = (0, _uniqBy3.default)(response.map(getNameAndType), 'id');
				return (0, _assign2.default)({}, state, { condition: conditions.slice(0, KEYWORD_MAX_LENGTH) });
			}
		case 'PROCEDURE_LANDING_PAGES_RECEIVED':
			{
				var procedures = (0, _uniqBy3.default)(response.map(getNameAndType), 'id');
				return (0, _assign2.default)({}, state, { procedure: procedures.slice(0, KEYWORD_MAX_LENGTH) });
			}
		case 'SPECIALTY_LANDING_PAGES_RECEIVED':
			{
				var specialties = (0, _uniqBy3.default)(response.map(getNameAndType), 'id');
				return (0, _assign2.default)({}, state, { specialty: specialties.slice(0, KEYWORD_MAX_LENGTH) });
			}
		default:
			return state || INITIAL_STATE;
	}
};


// WEBPACK FOOTER //
// ./components/home-page/lib/reducers/landing-pages.js